
import { addToCart, AddToCartResp } from './add-to-cart'
import { clearCart, ClearCartResp } from './clear-cart'
import { getCart, GetCartResp } from './get-cart'
import { mergeCart, MergeCartResp } from './merge-cart'
import { modifyCartItem, ModifyCartItemResp } from './modify-cart-item'
import { calculateCart, CalculateCartReq, CalculateCartRes } from './calculate-cart'
import { AddToCartReq, MergeCartReq, ModifyCartItemReq } from './types'

export type UseCartApi = () => {
  addToCart: (isdn: string, req: AddToCartReq) => Promise<AddToCartResp>
  clearCart: (isdn: string) => Promise<ClearCartResp>
  getCart: (isdn: string) => Promise<GetCartResp>
  mergeCart: (isdn: string, req: MergeCartReq) => Promise<MergeCartResp>
  modifyCartItem: (isdn: string, req: ModifyCartItemReq) => Promise<ModifyCartItemResp>
  calculateCart: (req: CalculateCartReq) => Promise<CalculateCartRes>
}

export const useCartApi: UseCartApi = () => {
  return {
    addToCart: async (isdn, req) => {
      return await addToCart(isdn, req)
    },
    clearCart: async (isdn) => {
      return await clearCart(isdn)
    },
    getCart: async (isdn) => {
      return await getCart(isdn)
    },
    mergeCart: async (isdn, req) => {
      return await mergeCart(isdn, req)
    },
    modifyCartItem: async (isdn, req) => {
      return await modifyCartItem(isdn, req)
    },
    calculateCart: async (req) => {
      return await calculateCart(req)
    }
  }
}

export default useCartApi
